// Libraries
import Router from 'vue-router';
import Store from '../store';

// Router files
import SearchRoutes from './Search';
import CrmRoutes from './Crm';
import ProjectsRoutes from './Projects';
import DocumentsRoutes from './Documents';
import ImagesRoutes from './Images';
import FinancialRoutes from './Financial';
import HrRoutes from './Hr';
import SocialRoutes from './Social';
import ErrorRoutes from './Errors';

let router;
if (document.getElementById('app')) {
    router = new Router({
        linkActiveClass: 'active',
        scrollBehavior: () => ({y: 0}),
        mode: 'history',
        routes: [
            {
                path: '/',
                redirect: '/dashboard',
                name: 'home',
            },
            {
                path: '/dashboard',
                redirect: '/my-pages',
                name: 'dashboard',
            },
            ...SearchRoutes,
            ...CrmRoutes,
            ...ProjectsRoutes,
            ...DocumentsRoutes,
            ...ImagesRoutes,
            ...FinancialRoutes,
            ...HrRoutes,
            ...SocialRoutes,

            // Error routes should always be listed last!
            ...ErrorRoutes,
        ]
    });

    router.beforeEach((to, from, next) => {
        if (Store.getters.isAuthenticated === false) {
            Store.dispatch('authenticate')
                .then(() => next());
        } else {
            next();
        }
    });

}
export default router;
